import {Injectable} from '@angular/core';
import {GenericService} from '../../core/commons/generic.service';
import {AuthService} from '../../core/security/auth.service';
import {QueryOptions} from '../../core/commons/query.options';
import {DynFormData} from '../domain/data/dyn-form-data';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/from';
import {Headers, RequestMethod, ResponseContentType} from '@angular/http';
import {FormService} from './form.service';

@Injectable()
export class FormDataService extends GenericService<DynFormData> {

    constructor(public authService: AuthService,
                public formService: FormService) {
        super(authService);
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    /*
    public get(id: number): Observable<DynFormData> {
        return super.get(id)
            .switchMap(formData => this.formService.valueToForm(formData.getForm())
                .map(form => {
                    formData.setForm(form);
                    return formData;
                }))
            .map(formData => {
                formData.getValues()
                    .forEach(v => v.setField(formData.getFieldByName(v.getField().name)));
                return formData;
            })
    }
*/

    public save(formData: DynFormData): Observable<DynFormData> {
        return formData.getId() ?
            this.update(formData) :
            this.create(formData);
    }

    public getUserFormsCompleted(): Observable<DynFormData[]> {
        /*
        const req = this.buildRequest(RequestMethod.Get);
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + '/my-forms', req)
            .map(res => res.json().map(t => this.valueToEntity(t)));
        */
        return this.doRequest({
            method: RequestMethod.Get,
            url: this.baseUrl + this.getResourcePath() + '/my-forms'
        }).concatMap(res => Observable.from(res.json())
            .concatMap(t => this.mapValueToEntityGetAll(t))
            .toArray()
        )
    }

    public downloadAsPdf(id: number): Observable<any> {
        const headers = new Headers();
        headers.set('Accept', 'application/pdf');
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/' + id + '/download/pdf',
            method: RequestMethod.Get,
            headers: headers,
            responseType: ResponseContentType.Blob
        })
            .map(res => new Blob([res.blob()], {type: 'application/pdf'}))
    }

    protected valueToEntity(value: any): DynFormData {
        return DynFormData.toEntity(value);
    }

    protected valueToEntityGet(value: any): Observable<DynFormData> {
        return this.formService.valueToForm(value.form)
            .map(form => DynFormData.toEntityDetail(value, form))
    }

    protected getResourcePath(): string {
        return '/formdata';
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/services/form-data.service.ts